export enum CodingReviewMode {
  ENCOUNTER = "Encounter",
  DIAGNOSIS = "Diagnosis",
  DIAGNOSIS_V3 = "DiagnosisV3",
}
